import React, { useEffect } from "react";

import {Route, Routes, Navigate} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Authentication from "./components/auth/Authentication";
import Spinner from "./components/common/spinner/Spinner";
import ContentWrapper from "./components/common/wrapper/ContentWrapper";

import { getUsers } from "./store/users/user-actions";
import { getSkills } from "./store/skills/skill-actions";
import { getQueues } from "./store/queues/queue-actions";

import * as routeConstants from "./constants/routeConstants";

import { getAbortSignal } from "./util/signalHelper";

const SkillLevels = React.lazy(() => import("./pages/skills/SkillLevels"));
const Users = React.lazy(() => import("./pages/users/Users"));
const Skills = React.lazy(() => import("./pages/skills/Skills"));
const Queues = React.lazy(() => import("./pages/queues/Queues"));
const QueueMembers = React.lazy(() => import("./pages/queues/QueueMembers"));
const Home = React.lazy(() => import("./pages/home/Home"));

const IS_DEV = process.env.REACT_APP_IS_DEV === 'true';

const App = () =>  {
  const dispatch = useDispatch();
  const {token, profile, isLoggedIn} = useSelector(state => state.auth);
  const {isLoading} = useSelector(state => state.loading);

  useEffect(() => {
    const [userSignal, userController] = getAbortSignal();
    const [skillSignal, skillController] = getAbortSignal();
    const [queueSignal, queueController] = getAbortSignal();

    console.log("App -> useEffect");
    if (!token) return;
    if (!profile) return;
    console.count("App -> useEffect: getUsers");
    dispatch(getUsers(token, userSignal));
    console.count("App -> useEffect: getSkills");
    dispatch(getSkills(token, skillSignal));
    console.count("App -> useEffect: getQueues");
    dispatch(getQueues(token, queueSignal));

    //profile and token will actually protect this useEffect from executing twice in react strict mode
    return () => {
      console.count("Authentication -> cancel profile");
      console.count("App -> cancel getUsers");
      userController.abort();
      console.count("App -> cancel getSkills");
      skillController.abort();
      console.count("App -> cancel getQueues");
      queueController.abort();
    }

  }, [dispatch, token, profile]);

  return (
    <Authentication>
      <Header />
      <ContentWrapper>
        <React.Suspense fallback={<Spinner />}>
          <Routes>
            <Route path={routeConstants.ROUTE_DEFAULT} element={<Home />} />
            {isLoggedIn && <Route path={routeConstants.ROUTE_SKILL_LEVELS} element={<SkillLevels />} />}
            {IS_DEV && isLoggedIn && <Route path={routeConstants.ROUTE_SKILLS} element={<Skills />} />}
            {IS_DEV && isLoggedIn && <Route path={routeConstants.ROUTE_USERS} element={<Users />} />}
            {IS_DEV && isLoggedIn && <Route path={routeConstants.ROUTE_QUEUES} element={<Queues />} />}
            {isLoggedIn && <Route path={routeConstants.ROUTE_QUEUE_MEMBERS} element={<QueueMembers />} />}
            <Route path={routeConstants.ROUTE_AUTH} element={<></>} />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </React.Suspense>
      </ContentWrapper>
      <Footer />
      {isLoading && <Spinner />}
    </Authentication>
  );
}

export default App;
